var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.04982 10.0776V19.7468C2.04982 19.814 2.07649 19.8784 2.12397 19.9258C2.17144 19.9733 2.23584 20 2.30298 20H5.89628C5.96343 20 6.02782 19.9733 6.0753 19.9258C6.12278 19.8784 6.14945 19.814 6.14945 19.7468V9.94692H8.75459C8.8177 9.94721 8.87864 9.92393 8.92547 9.88163C8.97231 9.83933 9.00165 9.78106 9.00776 9.71825L9.26092 6.76194C9.26316 6.72735 9.25827 6.69267 9.24655 6.66004C9.23483 6.62741 9.21654 6.59754 9.1928 6.57227C9.16907 6.54701 9.1404 6.52689 9.10857 6.51315C9.07674 6.49942 9.04242 6.49237 9.00776 6.49245H6.14945V4.36096C6.1494 4.24198 6.17321 4.12419 6.21947 4.01456C6.26573 3.90493 6.3335 3.80569 6.41877 3.7227C6.50404 3.63972 6.60509 3.57467 6.71593 3.5314C6.82677 3.48813 6.94516 3.46753 7.06411 3.4708H9.07309C9.14023 3.4708 9.20463 3.44413 9.2521 3.39665C9.29958 3.34918 9.32625 3.28478 9.32625 3.21764V0.253165C9.32625 0.186021 9.29958 0.121628 9.2521 0.0741506C9.20463 0.026673 9.14023 0 9.07309 0H5.65129C4.69612 0 3.78007 0.37944 3.10466 1.05485C2.42926 1.73025 2.04982 2.6463 2.04982 3.60147V6.45161H0.253164C0.186021 6.45161 0.121628 6.47829 0.0741506 6.52576C0.026673 6.57324 0 6.63763 0 6.70478V9.66109C0 9.72823 0.026673 9.79262 0.0741506 9.8401C0.121628 9.88758 0.186021 9.91425 0.253164 9.91425H2.04982V10.0776Z",
    fill: "#7BC0EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFacebook);
export default __webpack_public_path__ + "static/media/footer_facebook.0e5165a2db32097ac91a24291d5f1e12.svg";
export { ForwardRef as ReactComponent };